<!------------------------------------------------------------------------------
  Copyright (c) 2019. Keni Williams <kenneth.williams@estuk.co.uk>

  This file CheckoutForm.vue is part of event_pass_client.dev.
  Unauthorized copying of this file, via any medium is strictly prohibited.
  Proprietary and confidential
  CheckoutForm.vue can not be copied and/or distributed
  without the express permission of Keni Williams <kenneth.williams@estuk.co.uk>

  Reference: https://alligator.io/vuejs/stripe-elements-vue-integration/
  ----------------------------------------------------------------------------->

<template>
    <div>
        <template v-if="!basket_empty">

            <!-------------------------------------------------->
            <!--------------------Notify of success-------------------->
            <!-------------------------------------------------->
            <div data-ref="success notification" class="row">
                <div class="col-12">
                    <transition name="fade">
                        <CheckoutSuccessful
                                v-if="stripe.progress >= 100"
                                :show="stripe.progress >= 100"
                                :user_auth="user_auth"
                                :user_email="user_email"
                        ></CheckoutSuccessful>
                    </transition>
                </div>
            </div>
            <transition-group name="fade" tag="div">
                <article v-if="timed_out" class="row" :key="checkout_timer.closed">
                    <div class="col-12">
                        <h3 class="text-center">Tickets have been released back to the pool</h3>
                        <p class="text-center">You took too long to process your basket</p>
                        <div class="mt-5">
                            <a href="/" class="btn btn-primary">Go Shopping</a>
                        </div>
                    </div>
                </article>
                <article v-else :key="checkout_timer.open">
                    <form ref="form"
                          v-if="stripe.progress < 100"
                          :action="checkout_pay_url"
                          method="post"
                          @submit="checkForm"
                          autocomplete="on">
                        <input type="hidden"
                               name="_token"
                               :value="csrf">
                        <CheckoutItems
                                :basket="basket_data"
                                :basket_contents="basket_data.contents"
                                :ticket_types="ticket_types"
                                :voucher_response="voucher_response"
                                :voucher_code_status="voucher_code_status"
                                @add="add"
                                @remove="remove"
                                @clear_basket="clear_basket"
                                @validate_voucher_code="validateVoucher"
                                @null_voucher_response="nullVoucherResponse"
                                @total_basket_value="totalBasketValue"
                                @update_response_after_error="updateVoucherResponseAfterError"
                        ></CheckoutItems>
                        <h1 v-if="dev_mode">Timer {{checkout_timer.timeout_in_seconds}} Pause:{{checkout_timer.pause.set}}</h1>
                        <article v-if="warning_timer && !timed_out" class="row" :key="checkout_timer.warning">
                            <div class="col-12">
                                <div class="card bg-warning">
                                    <div class="card-body">
                                        <h5 class="text-center m-0">Complete your transaction in
                                            {{checkout_timer.timeout_in_seconds}}</h5>
                                    </div>
                                </div>
                            </div>
                        </article>
                        <div class="row">
                            <!-------------------------------------------------->
                            <!--------------------user auth -------------------->
                            <!-------------------------------------------------->
                            <template v-if="user_auth && use_auth">
                                <!-------------------- use saved card -------------------->
                                <template v-if="last_card_used!==null">
                                    <div v-if="!create_new_card"
                                         class="col-12 col-md-6 mb-4 mb-md-0 create_new_card">
                                        <CheckoutSavedCard
                                                :user_auth="user_auth"
                                                :last_card_used="last_card_used"
                                                class=" card z-depth-4"
                                                :class="{
                                                'bg-warning':card_error_vue
                                            }"
                                                :show_card="postcode_valid === true || capture_postcode === false"
                                                @create_card="createCard"
                                                @use_card="payWithSavedCard"
                                                :show_spinner="showLoader"
                                                :spinner_progress="stripe.progress"
                                        >
                                            <template v-if="capture_postcode">
                                                <PostCode name="postcode"
                                                          class="mb-2"
                                                          :maps_region="maps_region"
                                                          :maps_api_key="maps_api_key"
                                                          @postcode_valid="postCodeValid"
                                                ></PostCode>
                                            </template>
                                            <CheckoutStripeHiddenComponents :stripe="stripe"/>
                                        </CheckoutSavedCard>
                                    </div>
                                </template>
                                <!-------------------- no saved card --------------------->
                                <template v-else>
                                    <div class="col-12 col-md-6 mb-4 mb-md-0">
                                        <CheckoutNewCardDetails
                                                v-if="!free_purchase"
                                                :step="1"
                                                msg="Enter your card details"
                                                class=" card z-depth-4"
                                                :class="{
                                                'bg-warning':card_error_vue
                                            }">
                                            <slot>
                                                <p v-if="dev_mode">4000002500003155</p>
                                                <template v-if="capture_postcode">
                                                    <PostCode name="postcode"
                                                              class="mb-2"
                                                              :maps_region="maps_region"
                                                              :maps_api_key="maps_api_key"
                                                              @postcode_valid="postCodeValid"
                                                    ></PostCode>
                                                </template>
                                                <div v-show="postcode_valid === true || capture_postcode === false">
                                                    <input type="hidden"
                                                           name="save_card"
                                                           :value="new_card.save">
                                                    <div class="md-form" v-if="new_card.save">
                                                        <input type="text"
                                                               id="card_holder"
                                                               name="card_holder"
                                                               class="form-control">
                                                        <label for="card_holder">Name to identify card in future</label>
                                                    </div>
                                                    <div class="md-form">
                                                        <div id="new-saved-card-element"
                                                             class="pseudo-form pseudo-form-input transparent-autofill"
                                                             ref="new_saved_card">
                                                        </div>
                                                    </div>

                                                    <div class="md-form"
                                                         v-if="enable_one_click"
                                                    >
                                                        <input id="buy_now_card_2"
                                                               type="checkbox"
                                                               class="buy_now_checkbox"
                                                               data-card_token=""
                                                               v-model="new_card.buy_now"
                                                               name="activate_buy_now">

                                                        <label for="buy_now_card_2">Use for 1-click buy</label>
                                                    </div>
                                                    <BaseButton
                                                            v-if="show_pay_button && !checkout_active"
                                                            @click="pay(true)"
                                                            type="div"
                                                    >PAY NOW
                                                    </BaseButton>
                                                    <CheckoutStripeHiddenComponents :stripe="stripe"/>
                                                </div>
                                            </slot>
                                        </CheckoutNewCardDetails>
                                    </div>

                                    <div class="col-12 col-md-6 mb-4 mb-md-0">
                                        <!--------- free purchase ---------->
                                        <template v-if="free_purchase">
                                            <div class=" card z-depth-4 p-3">
                                                <h4 class="text-center">Congratulations! <br> No payment required</h4>
                                                <div class="d-flex justify-content-center align-content-center">
                                                    <BaseButton @click="noPaymentRequiredSubmit"
                                                                type="div"
                                                    >Get Tickets
                                                    </BaseButton>
                                                </div>
                                            </div>
                                        </template>
                                        <transition name="fade">
                                            <CheckoutRequestingSpinner
                                                    :show="showLoader"
                                                    :width="stripe.progress"
                                            ></CheckoutRequestingSpinner>
                                        </transition>
                                    </div>
                                </template>
                                <!----------------- create new saved card ---------------->
                                <div class="col-12 col-md-6">
                                    <transition name="fade">
                                        <CheckoutNewCardDetails
                                                v-if="create_new_card"
                                                :step=null
                                                text="new card details"
                                                msg="Enter your card details"
                                                class="card z-depth-4"
                                                :class="{
                                                'bg-warning':card_error_vue
                                            }">
                                            <slot>
                                                <p v-if="dev_mode">4000002500003155</p>
                                                <template v-if="capture_postcode">
                                                    <PostCode name="postcode"
                                                              class="mb-2"
                                                              :maps_region="maps_region"
                                                              :maps_api_key="maps_api_key"
                                                              @postcode_valid="postCodeValid"
                                                              v-show="!disableFormContent"
                                                    ></PostCode>
                                                </template>
                                                <div class="md-form">
                                                    <div id="new-card-element"
                                                         data-ref="new-card-element"
                                                         class="pseudo-form pseudo-form-input transparent-autofill"
                                                         ref="new_saved_card">
                                                    </div>
                                                </div>
                                                <div id="new-card-errors" role="alert"></div>
                                                <div class="md-form">
                                                    <input id="buy_now_card"
                                                           type="checkbox"
                                                           class="buy_now_checkbox"
                                                           data-card_token=""
                                                           checked="">
                                                    <label for="buy_now_card">Use for 1-click buy</label>
                                                </div>
                                                <BaseButton
                                                        v-if="show_pay_button && !checkout_active"
                                                        @click="pay(true)"
                                                        type="div"
                                                >Use this card
                                                </BaseButton>

                                                <CheckoutStripeHiddenComponents :stripe="stripe"/>

                                                <transition name="fade">
                                                    <CheckoutRequestingSpinner
                                                            :show="showLoader"
                                                            :width="stripe.progress"
                                                    ></CheckoutRequestingSpinner>
                                                </transition>
                                            </slot>
                                        </CheckoutNewCardDetails>
                                    </transition>
                                </div>
                            </template>
                            <!-------------------------------------------------->
                            <!--------------------guest user-------------------->
                            <!-------------------------------------------------->
                            <template v-else>
                                <div class="col-12 col-md-6 mb-4 mb-md-0">
                                    <CheckoutEmail
                                            :auth_email="auth_email"
                                            :step="1"
                                            class="card z-depth-4"
                                            @email_valid="emailValid"
                                            :disabled="disableFormContent"
                                            @trigger_pause="triggerPause"
                                    ></CheckoutEmail>
                                </div>
                                <div class="col-12 col-md-6">
                                    <transition name="fade">
                                        <CheckoutNewCardDetails
                                                v-if="!free_purchase"
                                                :step="2"
                                                class=" card z-depth-4"
                                                :class="{
                                                'bg-warning':card_error_vue
                                            }">
                                            <slot>
                                                <p v-if="dev_mode">4000002500003155</p>
                                                <template v-if="show_card_form">
                                                    <template v-if="capture_postcode">
                                                        <PostCode name="postcode"
                                                                  class="mb-2"
                                                                  :maps_region="maps_region"
                                                                  :maps_api_key="maps_api_key"
                                                                  @postcode_valid="postCodeValid"
                                                                  v-show="!disableFormContent"
                                                        ></PostCode>
                                                    </template>
                                                    <section
                                                            v-show="postcode_valid === true || capture_postcode === false">
                                                        <div class="md-form">
                                                            <div id="card-element"
                                                                 class="pseudo-form pseudo-form-input transparent-autofill"
                                                                 ref="card"
                                                                 v-show="!disableFormContent"
                                                            >
                                                            </div>
                                                        </div>
                                                        <div id="card-errors" role="alert"></div>
                                                        <BaseButton
                                                                v-if="show_pay_button && !checkout_active"
                                                                @click="pay"
                                                                type="div"
                                                        >Use this card
                                                        </BaseButton>
                                                        <CheckoutStripeHiddenComponents :stripe="stripe"/>
                                                    </section>
                                                </template>
                                                <transition name="fade">
                                                    <CheckoutRequestingSpinner
                                                            :show="showLoader"
                                                            :width="stripe.progress"
                                                    ></CheckoutRequestingSpinner>
                                                </transition>
                                            </slot>
                                        </CheckoutNewCardDetails>
                                    </transition>
                                    <template v-if="free_purchase && email_is_valid">
                                        <div class=" card z-depth-4 p-3">
                                            <h4 class="text-center">Congratulations! <br> No payment required</h4>
                                            <div class="d-flex justify-content-center align-content-center">
                                                <BaseButton @click="noPaymentRequiredSubmit"
                                                            type="div"
                                                >Get Tickets
                                                </BaseButton>
                                            </div>
                                        </div>
                                    </template>
                                </div>
                            </template>
                            <div class="col-12">
                                <div class="card my-4">
                                    <transition name="slideDown">
                                        <div class="alert alert-danger m-0 text-center"
                                             v-if="card_error_vue"
                                             v-on:click="card_error_vue=null"
                                        >
                                            <div>{{card_error_vue}}</div>
                                        </div>
                                    </transition>
                                </div>
                            </div>
                        </div>
                    </form>
                </article>
            </transition-group>
        </template>

        <!--        basket is empty-->
        <div class="m-lg-5" v-else>
            <h4>No items in your basket</h4>
            <div class="mt-5">
                <a href="/" class="btn btn-primary">View events</a>
            </div>
        </div>
    </div>
</template>

<script>
    import {checkout} from "./MixinCheckout";
    import axios from 'axios';
    import {_} from 'underscore';

    window.Vue.component('timerCountdown', require('../modals/timerCountdown'));
    window.Vue.component('PostCode', require('../../../../../app/Shared/Resources/Assets/js/components/PostCode'));
    window.Vue.component('CheckoutRequestingSpinner', require('./CheckoutRequestingSpinner'));
    window.Vue.component('CheckoutSuccessful', require('./CheckoutSuccessful'));
    window.Vue.component('CheckoutItems', require('./CheckoutItems'));
    window.Vue.component('CheckoutEmail', require('./CheckoutEmail'));
    window.Vue.component('CheckoutNewCardDetails', require('./CheckoutNewCardDetails'));
    window.Vue.component('CheckoutSavedCard', require('./CheckoutSavedCard'));
    window.Vue.component('CheckoutStripeHiddenComponents', require('./CheckoutStripeHiddenComponents'));

    let stripe = null;

    if (typeof Stripe !== 'undefined' && Stripe !== null) {
        stripe = Stripe(Window.StripeApiConfig.pk);
    }
    export default {
        name: "checkout-form",
        components: {},
        props: {
            auth_email: {
                type: String,
                default: null
            },
            use_auth: {
                type: Boolean,
                default: false
            },
            basket_timeout_in_seconds: {
                type: Number,
                default: 300
            },
            dev_mode: {
                type: Boolean,
                default: true
            },
            capture_postcode: {
                type: Boolean,
                default: false
            },
            enable_one_click: {
                type: Boolean,
                default: true
            },
            maps_region: {
                type: String,
                default: 'UK'
            },
            login_route: {
                type: String,
                default: '/login'
            },
            account_route: {
                type: String,
                default: '/account'
            },
            maps_api_key: {
                type: String,
                default: null
            },
            user_auth: {
                type: Boolean,
                default: false
            },
            card_error: {
                type: String,
                default: null
            },
            read_url: {
                type: String
            },
            add_url: {
                type: String
            },
            reserved_time_url: {
                type: String
            },
            remove_url: {
                type: String
            },
            clear_basket_url: {
                type: String
            },
            validate_voucher_code_url: {
                type: String
            },
            checkout_pay_url: {
                type: String
            },
            create_payment_intent: {
                type: String,
                default: null
            },
            payment_intent_request: {
                type: String,
                default: null
            },
            ticket_types: {
                type: Array,
                default: () => ['season', 'bulk', 'vip', 'single']
            },
            basket: {
                type: Object,
                default: {}
            },
            last_card_used: {
                type: Object,
                default: {}
            }
        },
        mixins: [checkout],
        mounted() {
            let self = this;

            self.loadBasket(self.basket);

            self.stripe.style.base.color = self.getThemeColor('body-text', 'color');
            self.stripe.style.base['::placeholder'].color = self.stripe.style.base.color;
            self.csrf = document
                .querySelector('meta[name="csrf-token"]')
                .getAttribute('content');

            self.extendReserveTime();

            if (!self.basket_empty) {
                self.$nextTick(function () {
                    if (self.user_auth) {
                        if (self.last_card_used == null && self.use_auth) {
                            self.initStripe('new_saved_card', self.$refs['new_saved_card'], stripe);
                        }
                    }
                });
            }
        },
        data() {
            return {
                message_cache:'',
                checkout_timer: {
                    open: 1,
                    closed: 2,
                    warning: 3,
                    timed_out: false,
                    timer: null,
                    /**
                     * @type {Number}
                     */
                    timeout_in_seconds: 300,
                    offset: 10,
                    less_offset: 20,
                    /**
                     * @type {Object} pause
                     * @type {Number} pause.flag
                     * @type {Boolean} pause.active
                     * @type {Number} pause.set
                     * @type {Number} pause.times.coupon
                     * @type {Number} pause.times.email_first
                     * @type {Number} pause.times.email_match
                     * @type {Number} pause.times.card
                     * @type {Object} pause.times
                     * */
                    pause: {
                        flag: null,
                        active: false,
                        set: 10,
                        times: {
                            coupon: 10,
                            email_first: 10,
                            email_match: 10,
                            card: 20
                        }
                    },

                },

                user_email: '',
                postcode_valid: false,
                csrf: null,
                basket_empty: true,
                can_show_card_form: true,
                show_card_form: false,
                card_form_needed: true,
                email_is_valid: false,
                total_basket: 10000,
                voucher_response: null,
                debugging: false,
                basket_data: {},
                tickets_clicked: [],
                toastr_last: {},
                toastr_options: {
                    newestOnTop: true,
                    progressBar: true,
                    timeOut: 6000,
                    positionClass: "toast-top-right",
                    showMethod: 'slideDown',
                    hideMethod: 'slideUp',
                    showDuration: "30",
                },
                create_new_card: false,
                new_card: {
                    save: false,
                    buy_now: false
                },
                voucher_code_status: null,
            }
        },
        methods: {
            loadBasket(basket){
                let self = this;

                if (stripe) {
                    self.basket_data = basket;
                    self.basket_empty = _.isEmpty(self.basket_data.contents);
                }
            },
            extendReserveTime() {
                let self = this;

                axios
                    .post(self.reserved_time_url, {})
                    /**
                     * @param {Number} response.data.seconds
                     * @param {Number} response.data.offset
                     * @param {Object} response.data
                     * @param {Object} response
                     */
                    .then(function (response) {
                        // console.log('axios response', response.data);
                        self.checkout_timer.timeout_in_seconds = response.data.seconds - response.data.offset;
                        self.checkout_timer.less_offset = self.checkout_timer.timeout_in_seconds - self.checkout_timer.offset;
                        self.setTimer();
                    })
                    .catch(function (e) {
                        // catch error if any
                        console.error('events fetch', e);
                    })
                    .then(function () {
                        // always executed
                    });
            },
            triggerPause(value) {
                let self = this;

                if (self.checkout_timer.pause.times.hasOwnProperty(value.target)) {
                    if(value.start){
                        self.setPauseTimerActive(self.checkout_timer.pause.times[value.target]);
                    }else{
                        self.resumeTimer();
                    }
                }
            },
            setPauseTimerActive(time) {
                let self = this;

                self.$set(self.checkout_timer.pause,'active',true);
                self.$set(self.checkout_timer.pause,'set',time);
// console.log('Activating element watcher',self.checkout_timer.pause.active);
            },
            resumeTimer() {
                let self = this;
                // console.log('Deactivating element watcher');
                self.checkout_timer.pause.active = false;
            },
            setTimer() {
                let self = this;

                self.checkout_timer.timer = setInterval(function () {
                    if (!self.checkout_timer.pause.active) {
                        self.decrementTimer();

                        if (self.checkout_timer.timeout_in_seconds === 0) {
                            self.basket.timed_out = true;
                            clearInterval(self.checkout_timer.timer);
                        }
                    }
                    else{
                        self.checkout_timer.pause.set = self.checkout_timer.pause.set - 1;
                        // console.log('self.checkout_timer.pause.set', self.checkout_timer.pause.set)
                        if (self.checkout_timer.pause.set === 0) {
                            self.resumeTimer();
                        }
                    }
                    let msg = 'self.checkout_timer.pause.active:' + self.checkout_timer.pause.active + ' self.checkout_timer.pause.set:' + self.checkout_timer.pause.set;
                    if(self.message_cache !== msg ){
                        self.message_cache = msg;
                        // console.log(self.message_cache)
                    }
                    // console.log(msg)

                }, 1000);
            },
            decrementTimer() {
                let self = this;
                self.checkout_timer.timeout_in_seconds = self.checkout_timer.timeout_in_seconds - 1;
                self.checkout_timer.less_offset = self.checkout_timer.less_offset - 1;
            },
            log() {
                console.log.apply(console, arguments);
            },
            postCodeValid(value) {
                let self = this;

                self.postcode_valid = value;
            },
            createCard() {
                let self = this;

                self.create_new_card = true;
                self.$nextTick(function () {
                    self.$nextTick(function () {
                        self.$nextTick(function () {
                            self.initStripe('new_saved_card', self.$refs['new_saved_card'], stripe);
                        });
                    });
                });
            },
            useCard() {
                let self = this;
                self.pay();
            },
            checkForm: function (e) {
                return false;
            },
            getThemeColor(type, css) {
                let element = window.document.getElementById('css-build-colors--' + type);

                let style = getComputedStyle(element);

                return style[css];
            },
            payWithSavedCard(init) {
                let self = this;
                self.initStripe('saved_card', self.$refs['saved_card'], stripe);

                self.initPaymentStatus();
                self.$nextTick(function () {
                    self.makeRequest(self.setProgress(true), self.create_payment_intent, self.$refs.form.getElementsByTagName('input'));
                });
            },

            /**
             * pay by card
             * Reference Step 1:
             * @link https://stripe.com/docs/payments/payment-intents/migration#elements-step-1
             * @param {Boolean} save
             */
            pay(save) {
                let self = this;
                clearTimeout(self.checkout_timer.timer);
                window.localStorage.ckhBskStatus = -1;

                self.initPaymentStatus();
                // console.log('save',save)
                self.stripe.data
                    .createPaymentMethod(
                        'card',
                        self.stripe.card
                    )
                    .then(function (result) {
                        // console.log('create payment method');
                        self.stripe.stage = 1;
                        // console.log('self.checkout_pay_url',self.checkout_pay_url)
                        // console.log('then...',result)
                        event.preventDefault();
                        if (result.error) {
                            // Inform the user if there was an error
                            self.card_errors = result.error.message;

                        } else {
                            /**
                             * @param {Object} paymentMethodResult.paymentMethod
                             * @param {Object} paymentMethodResult
                             */
                            let paymentMethodResult = result;
                            self.setProgress(true);

                            /**
                             * Add the paymentMethodId to stripe object and pass to request
                             */
                            if (typeof paymentMethodResult.paymentMethod === 'object') {
                                self.stripe.payment_method_id = paymentMethodResult.paymentMethod.id;
                            } else {
                                self.stripe.payment_method_id = paymentMethodResult.paymentMethod;
                            }
                            // Send paymentMethod.id to server

                            self.$nextTick(function () {
                                self.makeRequest(self.setProgress(true), self.checkout_pay_url, self.$refs.form.getElementsByTagName('input'));
                            });
                        }
                    })
            },
            noPaymentRequiredSubmit() {
                let self = this;
                self.makeRequest(self.setProgress(true), self.checkout_pay_url, self.$refs.form.getElementsByTagName('input'));
            },

            /**
             * Make request to server
             * @param progress
             * @param url
             * @param inputs
             */
            makeRequest(progress, url, inputs) {
                let self = this;
                self.setProgress(true);
                axios
                    .post(url, self.createFormData(inputs)) //'/ajax/confirm_payment'
                    /**
                     * @param {Boolean} response.requires_action
                     * @param {Object} response
                     */
                    .then(function (response) {
                        // console.log('response.data.requires_action',response.data.requires_action)
                        if (response.data.requires_action) {
                            self.stripe.stage = 1;
                            // console.log('action required. this will display the enter card code thingy');
                            self.handleCardActionResponse(response, false)
                                .then(function (result) {
                                    self.processStripeCardAction(result)
                                        .then(() => {
                                            console.log('process action now requesting charge to card. we can show the splash here');
                                            self.stripe.stage = 2;
                                            self.makeRequest(self.setProgress(true), self.checkout_pay_url, self.$refs.form.getElementsByTagName('input'));
                                        })
                                        .catch(error => {
                                            self.setError(error);
                                        });
                                });
                        } else if (response.data.hasOwnProperty('requires_confirmation')) {

                            self.handleCardActionResponse(response, true)
                                .then(function (result) {
                                    self.processStripeCardAction(result)
                                        .then(() => {
                                            self.makeRequest(self.setProgress(true), self.payment_intent_request, self.$refs.form.getElementsByTagName('input'));
                                        })
                                        .catch(error => {
                                            self.setError(error);
                                        });
                                })
                                .catch(error => {
                                    self.setError(error);
                                });
                        } else if (response.data.hasOwnProperty('success')) {
                            self.checkout_active = false;
                            self.stripe.progress = 100;
                        } else {
                            throw response;
                        }
                    })
                    .catch(error => {
                        self.setError(error);
                    })
                    .then(function () {
                        // always executed
                    });
            },
            resetCheckoutStage() {
                let self = this;
                self.stripe.payment_intent_id = null;
                self.stripe.progress = 0;
                self.show_pay_button = true;
                self.checkout_active = false;
            },
            totalBasketValue(data) {
                let self = this;

                self.total_basket = data;
                // if the value is zero then the form for the card isn't needed
                self.card_form_needed = (data > 0);
            },
            emailValid: function (data) {
                let self = this;
                // show the form if the value is greater than 0
                self.email_is_valid = data;

            },
            notEmptyObject(someObject) {
                return _.isEmpty(someObject);
            },
            validateVoucher(voucher) {
                let self = this;

                axios
                    .post(self.validate_voucher_code_url + `?timestamp=${new Date().getTime()}`, {
                        codes: voucher
                    })
                    /**
                     * @param {Object} response
                     */
                    .then(function (response) {
                        let success = false;

                        if (response.data === false) {
                        } else {
                            let basket = response.data.basket;

                            self.voucher_code_status = basket.status;
                            // check if the response basket has a discount
                            for (let i = 0; i < basket.basket.contents.length; i++) {
                                let val = basket.basket.contents[i];
// console.log('val',val);
                                if (val.ticket_data.hasOwnProperty('discount')) {
                                    success = true;
                                    break;
                                }
                            }

                            self.basket_data = basket.basket;
                            self.basket_empty = _.isEmpty(self.basket_data.contents);

                            // console.log(self.basket_data)
                        }
                        self.voucher_response = success;
                    })
                    .catch(function (e) {
                        // catch error if any
                        console.error('events fetch', e);
                    });
            },
            updateVoucherResponseAfterError() {
                let self = this;
                self.voucher_response = self.voucher_code_status = null;
            },
            nullVoucherResponse() {
                let self = this;
                self.voucher_response = self.voucher_code_status = null;
                self.read();
            },
            read() {
                let self = this;

                axios
                    .get(self.read_url, {})
                    /**
                     * @param {Object} response
                     */
                    .then(function (response) {
                        self.loadBasket(response.data.basket)
                    })
                    .catch(function (e) {
                        // catch error if any
                        console.error('events fetch', e);
                    });
            },
            /**
             * @param {Number} data.id
             * @param {Object} data.ticket
             * @param data
             */
            add(data) {
                let self = this;

                // check if the ticket has been requested already
                if (_.indexOf(self.tickets_clicked, data.id) >= 0) {
                    self.showToastr('warning', {
                        message: 'please wait while we get your ticket'
                    });
                    return false;
                } else {
                    let unix = new Date().getTime() / 1000;
                    // update the basket contents so the display is instant
                    self.$set(self.basket_data.contents, unix, data.ticket);

                    self.showToastr('info', {message: 'checking for available tickets'});
                    // add to tickets clicked to check
                    self.tickets_clicked.push(data.id);

                    //send the add request and update the contents was rejected
                    axios
                        .post(`${self.add_url}/${data.id}`, {})
                        /**
                         * @param {Object} response
                         */
                        .then(function (response) {

                            /**
                             * @param {Boolean} response.data.sold_out
                             * @param {Object} response.data
                             * @namespace {Object} response
                             * */
                            if (response.data.sold_out === true) {

                                /**
                                 * {Function} toastr
                                 */
                                self.clearToastr(self.toastr_last);

                                self.showToastr('warning', {message: 'this ticket is sold out'});
                                self.tickets_clicked = self.removeTicketFromWaitingList(data.id);
                                // remove ticket quantity from the list items

                                if (self.basket_data.contents !== null) {

                                    let tmp = _.clone(self.basket_data.contents);

                                    for (let i = 0; i < self.basket_data.contents.length; i++) {
                                        let quantity = self.basket_data.contents[i].quantity;
                                        if (typeof quantity !== 'undefined') {
                                            self.basket_data.contents[i].quantity = self.basket_data.contents[i].quantity - 1;
                                        }
                                    }
                                    self.$set(self.basket_data, 'contents', tmp);
                                }
                            } else if (response.data.exceeded === true) {
                                let maxNumberOfTickets = response.data.limit;
                                self.clearToastr(self.toastr_last);

                                self.showToastr('warning', {message: 'Only ' + maxNumberOfTickets + ' per purchase'});
                                self.tickets_clicked = self.removeTicketFromWaitingList(data.id);
                                if (self.basket_data.contents !== null) {

                                    let tmp = _.clone(self.basket_data.contents);

                                    for (let i = 0; i < self.basket_data.contents.length; i++) {
                                        let quantity = self.basket_data.contents[i].quantity;
                                        if (typeof quantity !== 'undefined') {
                                            self.basket_data.contents[i].quantity = self.basket_data.contents[i].quantity - 1;
                                        }
                                    }
                                    self.$set(self.basket_data, 'contents', tmp);
                                }

                            }
                            // ticket was not sold out so can be added to basket
                            else {


                                // remove the toastr from the dom
                                self.clearToastr();

                                // remove request from ticket clicked cache so it can be added again
                                self.tickets_clicked = self.removeTicketFromWaitingList(data.id);
                            }
                        })
                        .catch(function (e) {
                            // catch error if any
                            console.error('events fetch', e);
                        })
                }
            },
            /**
             * @param {Number} data.id
             * @param {Object} data.ticket
             * @param data
             */
            remove(data) {
                let self = this;

                axios
                    .post(`${self.remove_url}/${data.id}`, {})
                    /**
                     * @param {Object} response
                     */
                    .then(function (response) {
                        // removed ticket successfully
                        if (response.data.success) {

                            self.basket_data = response.data.basket;
                            self.basket_empty = _.isEmpty(self.basket_data.contents);
                        }
                    })
                    .catch(function (e) {
                        // catch error if any
                        console.error('events fetch', e);
                    });
            },
            clear_basket() {
                let self = this;

                axios
                    .get(self.clear_basket_url, {})
                    /**
                     * @param {Object} response
                     */
                    .then(function (response) {
                        // removed ticket successfully
                        if (response.data.success) {
                            // console.log(response.data.basket)
                            self.basket_data = {};
                            self.basket_empty = true;
                            window.localStorage.ckhBskStatus = -1;
                        }
                    })
                    .catch(function (e) {
                        // catch error if any
                        console.error('events fetch', e);
                    });
            },
            removeTicketFromWaitingList(ticket_id) {
                let self = this,
                    index = _.indexOf(self.tickets_clicked, ticket_id);

                if (index > -1) {
                    self.$delete(self.tickets_clicked, index);
                }

                return self.tickets_clicked;
            },
            showToastr(type, params) {
                let self = this,
                    title = ('title' in params) ? `<div>${params.title}</div>` : '',
                    message = `<div class="p-3">${params.message}</div>`
                ;

                toastr.options = self.toastr_options;

                self.toastr_last = toastr[type](
                    `${title}
		            ${message}`
                );
            },
            clearToastr(obj) {
                toastr.clear(obj);
            },
            /**
             * Shows card form after the user enters their email because they are not logged in
             */
            validateShowingCard() {
                let self = this;

                if (self.email_is_valid && self.card_form_needed) {
                    self.show_card_form = true;
                    self.$nextTick(function () {
                        self.initStripe('card', self.$refs['card'], stripe);
                    })
                }
            },
            /**
             * list all inputs and get all values for use on submit
             *
             **/
            createFormData(inputs) {
                let self = this;
                let formData = new FormData();
                /**
                 * list all inputs and get all values to submit
                 **/
                for (let input of inputs) {
                    // apply the input name and value to formData
                    formData.append(input.name, input.value);
                    if (input.name === 'guest_email') {
                        self.user_email = input.value;
                    }
                }
                return formData;
            },
        },
        watch: {
            basket(val) {
                this.basket_data = val;
                this.basket_empty = !this.notEmptyObject(val.contents);
            },
            email_is_valid(val) {
                if (val) {
                    this.validateShowingCard()
                } else {
                    this.show_card_form = false;
                }
            },
            card_form_needed(val) {
                if (val) {
                    this.validateShowingCard()
                } else {
                    this.show_card_form = false;
                }
            },
            'new_card.buy_now'(val) {
                this.new_card.save = val;
            }
        },
        computed: {
            timed_out() {
                if (this.checkout_timer.timeout_in_seconds <= 0) {
                    this.clear_basket();
                }
                return this.checkout_timer.timeout_in_seconds <= 0
            },
            warning_timer() {
                return this.checkout_timer.less_offset <= 0;
            },
            free_purchase() {
                return this.total_basket <= 0 && !this.checkout_active;
            },
            disableFormContent() {
                return this.checkout_active;
            },
            showLoader() {
                if (this.card_error_vue !== null) {
                    this.resetCheckoutStage();
                    return false;
                }
                return this.checkout_active;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/checkout/CheckoutForm.vue